const AboutPage = () => {
  const values = [
    {
      icon: 'fa-bullseye',
      title: 'Excellence',
      description: 'We strive for excellence in every project, delivering high-quality cloud infrastructure and enterprise solutions.',
      color: 'text-primary',
    },
    {
      icon: 'fa-handshake',
      title: 'Partnership',
      description: 'We work as strategic partners with our clients, building long-term relationships based on trust and results.',
      color: 'text-secondary',
    },
    {
      icon: 'fa-lightbulb',
      title: 'Innovation',
      description: 'We embrace cutting-edge cloud technologies and DevOps practices to deliver modern infrastructure solutions.',
      color: 'text-accent',
    },
    {
      icon: 'fa-shield-alt',
      title: 'Security',
      description: 'We prioritize security and compliance in every solution, protecting your infrastructure and data.',
      color: 'text-primary',
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-primary text-white py-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-6" data-aos="slide-right">
              About Kommonview
            </h1>
            <p className="text-xl text-gray-100" data-aos="slide-left" data-aos-delay="100">
              Empowering businesses through innovative digital solutions
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-6 text-center">
              A Technology Company
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed text-center mb-8">
              We are a cloud-first technology company that designs, builds, and operates modern digital infrastructure at scale.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed text-center">
              As your strategic partner, we deliver multi-cloud excellence (AWS, Azure, GCP), secure enterprise platforms,
              Atlassian-powered collaboration, bespoke software solutions, and high-impact digital advertising, all engineered
              to strengthen security, accelerate innovation, and drive measurable business outcomes.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-12 text-center">
            Our Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-8 text-center hover:shadow-xl transition-shadow"
              >
                <div className="w-16 h-16 mx-auto mb-4 bg-primary/10 rounded-xl flex items-center justify-center">
                  <i className={`fas ${value.icon} text-3xl ${value.color}`}></i>
                </div>
                <h3 className="text-xl font-heading font-bold mb-3 text-gray-900">
                  {value.title}
                </h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-6 text-center">
              Our Expertise
            </h2>
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                We specialize in designing and operating modern cloud infrastructure across AWS, Azure, and GCP.
                Our team brings deep expertise in enterprise IT infrastructure, cloud platforms, Atlassian services,
                and DevOps automation.
              </p>
              <p>
                From server and client compute support to complete cloud migrations and Atlassian implementations,
                we deliver comprehensive technology solutions that strengthen security, accelerate innovation,
                and drive measurable business outcomes.
              </p>
              <p>
                Whether you need IT infrastructure management, multi-cloud excellence, Atlassian-powered collaboration,
                or bespoke software development, we're your strategic technology partner.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
